<script lang="ts">
  import type { Target } from '@shared/types';
  import { is } from '@shared/utils';

  export let href: string | undefined = undefined;
  export let target: Target | undefined = undefined;
  export let hasDefaultColor = true;
</script>

<svelte:element
  this="{href ? 'a' : 'button'}"
  {href}
  {target}
  class="{is(
    hasDefaultColor,
    'text-default-900 dark:text-dark-900',
  )} underline-hover underline-top-1 underline-static before:bg-default-900/50 after:bg-default-600/50"
  on:click
  role="link"
  tabindex="0"
>
  <slot />
</svelte:element>
